import { render, staticRenderFns } from "./PolicyUpdate.vue?vue&type=template&id=7d321d94&"
import script from "./PolicyUpdate.vue?vue&type=script&lang=js&"
export * from "./PolicyUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports